module.exports = __webpack_public_path__ + "img/ios_mask.f6594daa.png";